var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { mergeProps, useFocusRing } from 'react-aria';
import { useId } from '../hooks';
import { Text } from '../text';
import Radiomark from './radiomark';
import { inputStaticStyle, labelStaticStyle, wrapperStyle } from './styles';
function RadioInternal(_a, ref) {
    var { 'aria-label': ariaLabel, checked = false, children, disabled = false, error = false, inverted = false, size = 'medium' } = _a, restProps = __rest(_a, ['aria-label', "checked", "children", "disabled", "error", "inverted", "size"]);
    const { focusProps, isFocusVisible } = useFocusRing();
    const radioId = `radio-${useId()}`;
    const hasChildren = children != null;
    return (_jsxs("div", Object.assign({ css: wrapperStyle({ disabled, inverted }) }, { children: [_jsx("input", Object.assign({}, mergeProps(focusProps, restProps), { ref: ref }, (hasChildren && { id: radioId }), { "aria-invalid": error, "aria-label": ariaLabel, checked: checked, css: inputStaticStyle, disabled: disabled, type: "radio" })), _jsx(Radiomark, Object.assign({}, { checked, disabled, error, isFocusVisible })), hasChildren && (_jsx(Text, Object.assign({ as: "label", css: labelStaticStyle, htmlFor: radioId, size: size }, { children: children })))] })));
}
export default RadioInternal;
